if (!customElements.get('modal-customization')) {
  customElements.define(
    'modal-customization',
    class ModalCustomization extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        this.debug = false;
        this.observer = null;
        this.num_slides = 1;
        this.max_num_slides = 2;
        this.current_slide = 1;
        this.char_limit = 7;
        this.personalization_icons = [];
        this.sku = '';
        this.model = '';
        this.finish = '';
        this.variant_id = '';
        this.badWordsList = [
          'ahole',
          'anus',
          'ash0le',
          'ash0les',
          'asholes',
          'ass',
          'Ass Monkey',
          'Assface',
          'assh0le',
          'assh0lez',
          'asshole',
          'assholes',
          'assholz',
          'asswipe',
          'azzhole',
          'bassterds',
          'bastard',
          'bastards',
          'bastardz',
          'basterds',
          'basterdz',
          'Biatch',
          'bitch',
          'bitches',
          'Blow Job',
          'boffing',
          'butthole',
          'buttwipe',
          'c0ck',
          'c0cks',
          'c0k',
          'cawk',
          'cawks',
          'Clit',
          'cnts',
          'cntz',
          'cock',
          'cockhead',
          'cocks',
          'crap',
          'cum',
          'cunt',
          'cunts',
          'cuntz',
          'dick',
          'dild0',
          'dild0s',
          'dildo',
          'dildos',
          'dilld0',
          'dilld0s',
          'dyke',
          'enema',
          'f u c k',
          'f u c k e r',
          'fag',
          'fag1t',
          'faget',
          'fagg1t',
          'faggit',
          'faggot',
          'fagg0t',
          'fagit',
          'fags',
          'fagz',
          'faig',
          'faigs',
          'fart',
          'fuck',
          'fucker',
          'fuckin',
          'fucking',
          'fucks',
          'fuk',
          'Fukah',
          'Fuken',
          'fuker',
          'Fukin',
          'Fukk',
          'Fukkah',
          'Fukken',
          'Fukker',
          'Fukkin',
          'g00k',
          'God-damned',
          'h00r',
          'h0ar',
          'h0re',
          'hells',
          'hoar',
          'hoor',
          'hoore',
          'h4ndjob',
          'hand job',
          'hand jobs',
          'handj0b',
          'handjob',
          'handjobs',
          'hndjob',
          'jerkoff',
          'rim job',
          'rimjob',
          'jackoff',
          'jap',
          'japs',
          'jerk-off',
          'jisim',
          'jiss',
          'jizm',
          'jizz',
          'knob',
          'knobs',
          'knobz',
          'kunt',
          'kunts',
          'kuntz',
          'Lezzian',
          'Lipshits',
          'Lipshitz',
          'masochist',
          'masokist',
          'n1gr',
          'nastt',
          'nigger;',
          'nigur;',
          'niiger;',
          'niigr;',
          'orafis',
          'orgasim;',
          'orgasm',
          'orgasum',
          'orgazm',
          'oriface',
          'orifice',
          'orifiss',
          'packi',
          'packie',
          'packy',
          'paki',
          'pakie',
          'paky',
          'pecker',
          'peeenus',
          'peenus',
          'peinus',
          'pen1s',
          'penas',
          'penis',
          'penus',
          'penuus',
          'Phuc',
          'Phuck',
          'Phuk',
          'Phuker',
          'Phukker',
          'polac',
          'polack',
          'polak',
          'Poonani',
          'pr1c',
          'pr1ck',
          'pr1k',
          'pusse',
          'pussee',
          'pussy',
          'puuke',
          'puuker',
          'qweir',
          'recktum',
          'rectum',
          'retard',
          'sadist',
          'scank',
          'schlong',
          'screwing',
          'semen',
          'sex',
          'sexy',
          'Sh!t',
          'sh1t',
          'sh1ter',
          'sh1ts',
          'sh1tter',
          'sh1tz',
          'shit',
          'shits',
          'shitter',
          'Shitty',
          'Shity',
          'shitz',
          'Shyt',
          'Shyte',
          'Shytty',
          'Shyty',
          'skanck',
          'skank',
          'skankee',
          'skankey',
          'skanks',
          'Skanky',
          'slag',
          'slut',
          'sluts',
          'Slutty',
          'slutz',
          'tit',
          'turd',
          'va1jina',
          'vag1na',
          'vagiina',
          'vagina',
          'vaj1na',
          'vajina',
          'vullva',
          'vulva',
          'w0p',
          'wh00r',
          'wh0re',
          'whore',
          'xrated',
          'xxx',
          'b!+ch',
          'bitch',
          'blowjob',
          'clit',
          'arschloch',
          'fuck',
          'shit',
          'ass',
          'asshole',
          'b!tch',
          'b17ch',
          'b1tch',
          'bastard',
          'bi+ch',
          'boiolas',
          'buceta',
          'c0ck',
          'cawk',
          'chink',
          'cipa',
          'clits',
          'cock',
          'cum',
          'cunt',
          'dildo',
          'dirsa',
          'ejakulate',
          'fatass',
          'fcuk',
          'fuk',
          'fux0r',
          'hoer',
          'hore',
          'jism',
          'kawk',
          'l3itch',
          'l3i+ch',
          'masturbate',
          'masterbat*',
          'masterbat3',
          's.o.b.',
          'mofo',
          'nazi',
          'nigga',
          'nigger',
          'nutsack',
          'phuck',
          'pimpis',
          'pusse',
          'pussy',
          'scrotum',
          'sh!t',
          'shemale',
          'shi+',
          'sh!+',
          'slut',
          'smut',
          'teets',
          'tits',
          'boobs',
          'b00bs',
          'teez',
          'testical',
          'testicle',
          'titt',
          'w00se',
          'jackoff',
          'wank',
          'whoar',
          'whore',
          '*damn',
          '*dyke',
          '*fuck*',
          '*shit*',
          '@$$',
          'amcik',
          'andskota',
          'arse*',
          'assrammer',
          'ayir',
          'bi7ch',
          'bitch*',
          'bollock*',
          'breasts',
          'cabron',
          'cazzo',
          'chraa',
          'chuj',
          'Cock*',
          'cunt*',
          'd4mn',
          'daygo',
          'dego',
          'dick*',
          'dike*',
          'dupa',
          'dziwka',
          'ejackulate',
          'Ekrem*',
          'Ekto',
          'enculer',
          'faen',
          'fag*',
          'fanculo',
          'fanny',
          'feces',
          'feg',
          'Felcher',
          'ficken',
          'fitt*',
          'Flikker',
          'foreskin',
          'Fotze',
          'fuk*',
          'futkretzn',
          'gook',
          'guiena',
          'h0r',
          'h4x0r',
          'hell',
          'helvete',
          'hoer*',
          'honkey',
          'Huevon',
          'hui',
          'injun',
          'jizz',
          'kanker*',
          'kike',
          'klootzak',
          'kraut',
          'knulle',
          'kuk',
          'kuksuger',
          'Kurac',
          'kurwa',
          'kusi*',
          'kyrpa*',
          'lesbo',
          'mamhoon',
          'masturbat*',
          'merd*',
          'mibun',
          'monkleigh',
          'mouliewop',
          'muie',
          'mulkku',
          'muschi',
          'nazis',
          'nepesaurio',
          'nigger*',
          'orospu',
          'paska*',
          'perse',
          'picka',
          'pierdol*',
          'pillu*',
          'pimmel',
          'piss*',
          'pizda',
          'poontsee',
          'poop',
          'porn',
          'p0rn',
          'pr0n',
          'preteen',
          'pula',
          'pule',
          'puta',
          'puto',
          'qahbeh',
          'queef*',
          'rautenberg',
          'schaffer',
          'scheiss*',
          'schlampe',
          'schmuck',
          'screw',
          'sh!t*',
          'sharmuta',
          'sharmute',
          'shipal',
          'shiz',
          'skribz',
          'skurwysyn',
          'sphencter',
          'spic',
          'splooge',
          'suka',
          'b00b*',
          'testicle*',
          'titt*',
          'twat',
          'vittu',
          'wank*',
          'wetback*',
          'wichser',
          'wop*',
          'yed',
          'zabourah',
        ];
        this.pr_icon = '';
        this.pr_text = '';
        this.onProductChangeUnsubscriber = undefined;
        this.submitButton = document.getElementById('btn_personalization_save');
        this.closeButton = document.querySelector('.modal-header .close');
        this.resetButton = this.querySelector('[data-modal-reset-button]');
        this.personalization_type = this.getAttribute('data-pr-type');
        if (this.debug) console.log('ModalCustomization constructor');
        this.personalization_icons = this.querySelectorAll('.personalizationIcon');
        this.form = document.querySelector('.add-to-cart-form');
        const id = this.form.querySelector('[name="id"]').value;
        this.setModalValues(id);

        this.setupObserver();
      }
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        if (this.debug) console.log('ModalCustomization connectedCallback');
        this.resetCustomize();
        this.onProductChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productChange, this.resetCustomize.bind(this));
      }

      disconnectedCallback() {
        this.onProductChangeUnsubscriber();
      }

      setupObserver() {
        if (this.debug) console.log('setupObserver()');
        const modal_customization_container = document.querySelector('modal-customization');
        modal_customization_container.attachListeners();
      }

      attachListeners() {
        if (this.debug) console.log('attachListeners');

        this.personalization_icons.forEach((personalization_icon) => {
          personalization_icon.addEventListener('click', (event) => {
            let current_status = event.currentTarget.dataset.modalButtonState;
            // make all other icons inactive by setting [data-modal-button-state] to 'inactive'
            this.personalization_icons.forEach((icon) => {
              icon.dataset.modalButtonState = 'inactive';
            });
            // if current_status was 'active' before we made all icons inactive was 'inactive', then leave it as 'inactive', else set it to 'active'
            event.currentTarget.dataset.modalButtonState = current_status === 'active' ? 'inactive' : 'active';
            // if the status is now active, we can set the pr_icon value
            if (event.currentTarget.dataset.modalButtonState === 'active') {
              this.pr_icon = event.currentTarget.dataset.iconValue;
            } else {
              this.pr_icon = '';
            }
            const pr_text = document.getElementById('pr_text').value;
            this.pr_text = pr_text;
            this.setPersonalization(pr_text, this.pr_icon);
          });
        });
        this.noPersonalizationListener();
        this.initTextListener();
        this.closeButtonListener();
        this.saveButtonListener();
        this.resetButtonsListeners();
        this.blurBackgroundClickEventListener();
        this.customModalOpenedListener();
        document.addEventListener('add-to-cart-form:updated', () => {
          const id = this.form.querySelector('[name="id"]').value;
          this.setModalValues(id);
          // if there's any saved personalization data, store it
          let has_saved_personalization = false;
          for (let i = 1; i <= this.max_num_slides; i++) {
            const keys = [`saved_pr_text_${i}`, `saved_pr_icon_${i}`];
            // loop through each key and if it exists, remove it
            keys.forEach((key) => {
              // if key exists in sessionStorage, remove it
              if (key in window.sessionStorage) {
                has_saved_personalization = true;
              }
            });
          }
          if (has_saved_personalization) {
            this.storePersonalizationData();
          }
        });
      }
      customModalOpenedListener() {
        if (this.debug) console.log('customModalOpenedListener');
        //modal-window-opened
        document.addEventListener('modal-window-opened', (event) => {
          // wait a split second before checking if the modal open is the customization modal
          setTimeout(() => {
            // see if modal_customization is open
            const modal_customization = document.querySelector('#modal_customization.modal-visuallyshow');
            // if open, we update the customizeSwiper (to show the pagniation)
            if (modal_customization) {
              window.customizeSwiper.update();
            }
          }, 100);
        });
      }

      noPersonalizationListener() {
        // when data-config-customize="false" is clicked, we should reset the personalization values
        const self = this;
        const customizeBlockResetBtn = document.querySelector('[data-config-customize="false"]');
        if (customizeBlockResetBtn) {
          customizeBlockResetBtn.addEventListener('click', function () {
            self.resetCustomize();
          });
        }
      }

      closeButtonListener() {
        if (this.debug) console.log('closeButtonListener');
        const self = this;
        this.closeButton.addEventListener('click', () => {
          // wait a split second before checking if we should close the modal
          setTimeout(() => {
            this.checkAndResetCustomization();
          }, 100);
        });
      }

      blurBackgroundClickEventListener() {
        const modal_customization_container = document.querySelector('#modal_customization');
        if (modal_customization_container) {
          modal_customization_container.addEventListener('click', (event) => {
            // Ensure the click is on the container and not on its children
            if (event.target === modal_customization_container) {
              this.checkAndResetCustomization();
            }
          });
        }
      }

      // Helper function to check sessionStorage and reset customization
      checkAndResetCustomization() {
        const savedPrText1 = window.sessionStorage.getItem('saved_pr_text_1');
        const savedPrText2 = window.sessionStorage.getItem('saved_pr_text_2');
        const savedPrIcon1 = window.sessionStorage.getItem('saved_pr_icon_1');
        const savedPrIcon2 = window.sessionStorage.getItem('saved_pr_icon_2');

        // If no customization is saved, reset the customization block
        if (!savedPrText1 && !savedPrText2 && !savedPrIcon1 && !savedPrIcon2) {
          const resetBtn = document.querySelector('[data-config-customize="false"]');
          if (resetBtn) resetBtn.click();
        } else {
          // if there's a saved pr_text or pr_icon, let's set the saved values to those
          const pr_text_1 = savedPrText1 ? savedPrText1 : '';
          const pr_icon_1 = savedPrIcon1 ? savedPrIcon1 : '';
          const pr_text_2 = savedPrText2 ? savedPrText2 : '';
          const pr_icon_2 = savedPrIcon2 ? savedPrIcon2 : '';
          window.sessionStorage.setItem('pr_text_1', pr_text_1);
          window.sessionStorage.setItem('pr_icon_1', pr_icon_1);
          window.sessionStorage.setItem('pr_text_2', pr_text_2);
          window.sessionStorage.setItem('pr_icon_2', pr_icon_2);
          let setFinish = this.getCleanedFinish();

          const { hexcolor, iconcolor } = this.getHexColor(setFinish);

          for (let i = 1; i <= this.max_num_slides; i++) {
            const previewText = document.querySelector(`#preview-text-${i}`);
            const pr_text = window.sessionStorage.getItem(`pr_text_${i}`)
              ? window.sessionStorage.getItem(`pr_text_${i}`)
              : '';
            const pr_icon = window.sessionStorage.getItem(`pr_icon_${i}`)
              ? window.sessionStorage.getItem(`pr_icon_${i}`)
              : '';
            if (previewText) {
              if (pr_icon == '' || this.personalization_type === 'embroidery') {
                previewText.innerHTML = `<div class="text_without_icon TextColor-${hexcolor}">${pr_text}</div>`;
              } else {
                previewText.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/2804/6630/files/${pr_icon}_${iconcolor}.png?v=1697069963" alt="${pr_icon} icon"  width="21" height="21"><div class="text_with_icon TextColor-${hexcolor}">${pr_text}</div>`;
              }
            }
          }
          // now we set the saved values to the input text and icon
          // first we find out which slide index is the active index
          const personalization_index = window.customizeSwiper.activeIndex + 1;
          // if there's a window.sessionStorage.getItem() value, we set that value, else we set it to ''
          const viewed_saved_pr_text = window.sessionStorage.getItem(`saved_pr_text_${personalization_index}`)
            ? window.sessionStorage.getItem(`saved_pr_text_${personalization_index}`)
            : '';
          const viewed_saved_pr_icon = window.sessionStorage.getItem(`saved_pr_icon_${personalization_index}`)
            ? window.sessionStorage.getItem(`saved_pr_icon_${personalization_index}`)
            : '';
          const activeIcon = document.querySelector(`.personalizationIcon[data-icon-value="${viewed_saved_pr_icon}"]`);
          if (activeIcon) {
            // reset all icons to inactive, then make the saved icon with data-modal-button-state="active"
            const personalization_icons = document.querySelectorAll('.personalizationIcon');
            personalization_icons.forEach((icon) => {
              icon.dataset.modalButtonState = 'inactive';
            });
            activeIcon.dataset.modalButtonState = 'active';
          }
          // we set the input text value to the saved text
          const textInput = document.querySelector('[data-input-personalization-text]');
          if (textInput) textInput.value = viewed_saved_pr_text;
        }
      }

      setModalValues(variant_id) {
        if (this.debug) console.log('setModalValues');
        // get product_id from local storage
        const product_id = window.localStorage.getItem('product_id');
        if (this.debug) console.log('this.product_id: ', product_id);
        const json_config_product_variant = document.querySelector(
          `script[data-json-config-product-id="${product_id}"]`
        );
        let targetVariant;
        if (json_config_product_variant) {
          const jsonData = JSON.parse(json_config_product_variant.innerHTML);
          // if finish is not provided, we are trying to look up this variant by variant_id
          targetVariant = jsonData.variants.find(function (variant) {
            return variant.id === variant_id;
          });
          // get model from json_config_product_variant attribute of data-json-config-model
          this.model = json_config_product_variant.getAttribute('data-json-config-model');
          if (targetVariant) {
            this.finish = targetVariant.finish;
            this.sku = targetVariant.sku;
          }
          if (this.debug) console.log('this.sku: ', this.sku);
          if (this.debug) console.log('this.variant_id: ', this.variant_id);
          if (this.debug) console.log('this.finish: ', this.finish);
          this.updatePersonalizationModal();
        }
      }
      saveButtonListener() {
        if (this.debug) console.log('saveButtonListener');
        const self = this;
        this.submitButton.addEventListener('click', async function () {
          await self.storePersonalizationData();
          //      setPersonalizationVariant();
          // wait for storePersonalizationData to finish before closing the modal

          // if personalizationSaveButton is not disabled, close the modal
          if (!self.submitButton.disabled) {
            self.closeModal();
          }
        });
      }

      resetButtonsListeners() {
        if (this.debug) console.log('resetButtonsListeners');
        const self = this;
        this.resetButton.addEventListener('click', function () {
          self.resetCustomize();
        });
      }

      closeModal() {
        // get saved_pr_hexcolor_1 and saved_pr_hexcolor_2 from sessionStorage, if both are not there or '', then we know there was no personalization and we should close the modal and click the [data-config-customize="false"] button
        const saved_pr_text_1 = window.sessionStorage.getItem('saved_pr_text_1');
        const saved_pr_text_2 = window.sessionStorage.getItem('saved_pr_text_2');
        const saved_pr_icon_1 = window.sessionStorage.getItem('saved_pr_icon_1');
        const saved_pr_icon_2 = window.sessionStorage.getItem('saved_pr_icon_2');
        if (!saved_pr_text_1 && !saved_pr_text_2 && !saved_pr_icon_1 && !saved_pr_icon_2) {
          console.log('closeModal');
          const customizeBlockResetBtn = document.querySelector('[data-config-customize="false"]');
          if (customizeBlockResetBtn) {
            customizeBlockResetBtn.click();
          }
        }
        this.closeButton.click();
      }

      initTextListener() {
        const pr_type = document.querySelector('[data-pr-type]').dataset.prType;
        const inputPersonalizationsText = document.querySelectorAll('[data-input-personalization-text]');
        inputPersonalizationsText.forEach((textInput) => {
          const self = this; // Save the correct `this` context

          textInput.addEventListener('input', function () {
            let pr_text = this.value;
            const char_limit = textInput.getAttribute('maxlength') || 0;

            if (pr_text.length > char_limit) {
              // Handle max length exceeded
            } else {
              // Remove emojis and non-valid characters from text
              let characterArray = pr_text.split('');
              let regexRule = /^[ ~`!@#$%^&*()_+=[\]\{}|;':",.\/<>?a-zA-Z0-9-]+$/;
              if (pr_type === 'embroidery') {
                regexRule = /^[a-zA-Z0-9 !"%'&(),\.\-:;`]+$/;
              }
              const filterArray = characterArray.filter((char) => regexRule.test(char));
              pr_text = filterArray.join('');

              const submitButton = document.getElementById('btn_personalization_save');

              // Now you can safely call `self.isProfane`
              if (self.isProfane(pr_text)) {
                // Use `self` instead of `this`
                submitButton.disabled = true;
              } else {
                submitButton.disabled = false;
              }

              textInput.value = pr_text;

              if (self.personalization_type === 'uv_printing') {
                let this_pr_icon = '';
                const active_pr_icon = document.querySelector('.personalizationIcon[data-modal-button-state="active"]');
                if (active_pr_icon) {
                  this_pr_icon = active_pr_icon.getAttribute('data-icon-value');
                }

                // const pr_icon = document.getElementById('pr_icon').value;
                // const pers_index = window.customizeSwiper.activeIndex - 1;
                // const pr_icon = window.sessionStorage.getItem(`pr_icon_${pers_index}`)
                self.setPersonalization(pr_text, this_pr_icon);
              } else {
                self.setPersonalization(pr_text);
              }
            }
          });

          /*
          this.observeElement(textInput, 'value', function (oldValue, newValue) {
            const pr_text = newValue;
            if (self.debug) console.log('pr_text: ', pr_text);
            if (self.debug) console.log('pr_icon: ', self.pr_icon);
            // get pr_icon from sessionStorage
            const pr_icon = window.sessionStorage.getItem(`pr_icon_${window.customizeSwiper.activeIndex}`);
            if (self.personalization_type === 'uv_printing') {
              // const pr_icon = document.getElementById('pr_icon').value;
              // const pers_index = window.customizeSwiper.activeIndex - 1;
              // const pr_icon = window.sessionStorage.getItem(`pr_icon_${pers_index}`)
              self.setPersonalization(pr_text, pr_icon);
            } else {
              self.setPersonalization(pr_text);
            }
          });
*/
        });
      }

      observeElement(element, property, callback, delay = 0) {
        const elementPrototype = Object.getPrototypeOf(element);
        if (elementPrototype.hasOwnProperty(property)) {
          const descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property);
          Object.defineProperty(element, property, {
            get: function () {
              return descriptor.get.apply(this, arguments);
            },
            set: function () {
              let oldValue = this[property];
              descriptor.set.apply(this, arguments);
              let newValue = this[property];
              if (typeof callback == 'function') {
                setTimeout(callback.bind(this, oldValue, newValue), delay);
              }
              return newValue;
            },
            configurable: true,
          });
        }
      }
      updatePersonalizationModal() {
        if (this.debug) console.log('updatePersonalizationModal()');
        const slide_count = this.getTotalSlidesNumber();

        // Get Option Values
        const this_finish = this.getCleanedFinish();

        const this_model = this.getCleanedModel();
        const { hexcolor, iconcolor } = this.getHexColor(this_finish);

        const previewTexts = document.querySelectorAll('.personalization-preview__wrapper .preview-text');
        const background_images = document.querySelectorAll('.personalization-preview__wrapper .background-image');

        // set max character limit for text input
        const text_input = document.querySelector('#pr_text');
        // set character limit based on personalization type and number of personalizations
        // const total_slides = document.querySelector('#product_personalization_modal').dataset.totalSlides;
        if (this.personalization_type === 'embroidery' && slide_count === 1) {
          this.char_limit = 10;
          text_input.setAttribute('maxlength', this.char_limit);
        } else if (this.personalization_type === 'embroidery' && slide_count > 1) {
          this.char_limit = 8;
          text_input.setAttribute('maxlength', this.char_limit);
        } else if (this.personalization_type === 'uv_printing') {
          this.char_limit = 7;
          text_input.setAttribute('maxlength', this.char_limit);
        }

        for (let i = 1; i <= slide_count; i++) {
          // get current text/icon values
          const pr_text = window.sessionStorage.getItem(`pr_text_${i}`)
            ? window.sessionStorage.getItem(`pr_text_${i}`)
            : '';
          const pr_icon = window.sessionStorage.getItem(`pr_icon_${i}`)
            ? window.sessionStorage.getItem(`pr_icon_${i}`)
            : '';
          // console.log(`pr_text: ${pr_text}; pr_icon: ${pr_icon}`);
          const prIndex = i - 1; // get 0th index

          // set hexcolor and background image
          if (this.personalization_type === 'embroidery') {
            //          https://cdn.shopify.com/s/files/1/2804/6630/files/personalization_hamper_white_single.jpg?v=1704496923
            background_images[prIndex].style.backgroundImage = `
            url(https://cdn.shopify.com/s/files/1/2804/6630/files/personalization_hamper_${this_finish}_${this_model}.jpg?v=1704496923)
          `;
            previewTexts[prIndex].innerHTML = `
            <div class="text_without_icon TextColor-${hexcolor}">${pr_text}</div>
          `;
          } else {
            background_images[prIndex].style.backgroundImage = `
            url(https://cdn.shopify.com/s/files/1/2804/6630/files/personalization_9oz_lsp_${this_finish}.png?v=1704335588)
            `;
            if (pr_icon === '') {
              previewTexts[prIndex].innerHTML = `
              <div class="text_with_icon TextColor-${hexcolor}">${pr_text}</div>
            `;
            } else {
              previewTexts[prIndex].innerHTML = `
              <img src="https://cdn.shopify.com/s/files/1/2804/6630/files/${pr_icon}_${iconcolor}.png?v=1697069963" alt="${pr_icon} icon"  width="21" height="21">
              <div class="text_with_icon TextColor-${hexcolor}">${pr_text}</div>
            `;
            }
          }
          // Set hexcolor for slides and sessionStorage
          window.sessionStorage.setItem(`saved_pr_hexcolor_${i}`, hexcolor);
          window.sessionStorage.setItem(`pr_hexcolor_${i}`, hexcolor);
          // const savedColor = window.sessionStorage.getItem(`pr_hexcolor_${i}`);
          // console.log(`savedColor: ${savedColor}`);
        }
      }
      setPersonalization(pr_text = '', pr_icon = '') {
        const personalization_index = window.customizeSwiper.activeIndex + 1;
        if (this.debug) console.log('personalization_index', personalization_index);

        const this_finish = this.getCleanedFinish();

        const { hexcolor, iconcolor } = this.getHexColor(this_finish);

        const pr_type = document.querySelector('[data-pr-type]').dataset.prType;
        const previewText = document.querySelector('.preview-container.swiper-slide-active .preview-text');
        if (previewText) {
          if (pr_icon == '' || this.personalization_type === 'embroidery') {
            previewText.innerHTML = `<div class="text_without_icon TextColor-${hexcolor}">${pr_text}</div>`;
          } else {
            previewText.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/2804/6630/files/${pr_icon}_${iconcolor}.png?v=1697069963" alt="${pr_icon} icon"  width="21" height="21"><div class="text_with_icon TextColor-${hexcolor}">${pr_text}</div>`;
          }
        }
        // console.log("setPersonalization() hexcolor: ", hexcolor);
        // set the values in session storage
        window.sessionStorage.setItem(`previewText_${personalization_index}`, previewText?.innerHTML);
        window.sessionStorage.setItem(`pr_text_${personalization_index}`, pr_text);
        if (pr_icon && pr_icon != '') {
          window.sessionStorage.setItem(`pr_icon_${personalization_index}`, pr_icon);
        } else {
          window.sessionStorage.removeItem(`pr_icon_${personalization_index}`);
        }
        window.sessionStorage.setItem(`pr_hexcolor_${personalization_index}`, hexcolor);
      }

      // create function to store personalization data in session storage when save is clicked, it's being called with await
      storePersonalizationData = async () => {
        if (this.debug) console.log('storePersonalizationData');
        let _personalization_data = {};
        const slide_count = this.getTotalSlidesNumber();
        if (this.debug) console.log(`slide_count: ${slide_count}`);

        let show_edit_personalization = false;
        const addedValuesWrapper = document.querySelector('[data-customize-summary-wrapper]');
        /*
        <input id="properties-personalization_1" type="hidden" name="properties[_pr_item_description_1]" value="ssp_body 9oz brushed with icon and text">
        <input id="properties-personalization_db_1" type="hidden" name="properties[_pr_db_1]" value='{"type":"ssp_body","size":"9oz", "color":"brushed","print_color":"#63666A","print_text":"suds","font":"DIN Light","font_size":"12px","print_icon":"dish","icon_size":"10mm","template_name":"9oz_brushed_icon_text"}'>
      */
        // convert this.model to lowercase and no spaces
        const this_model = this.getCleanedModel();
        // convert this.finish to lowercase
        const this_finish = this.getCleanedFinish();
        const personalization_item_desc_value = `${this.personalization_type} ${this_model} ${this_finish}`;
        // eslint-disable-next-line dot-notation
        _personalization_data[`_pr_item_description`] = personalization_item_desc_value;
        // console.log(personalization_item_desc_value);
        // loop through number of slides to save personalization data from session storage
        for (let i = 1; i <= slide_count; i++) {
          const pr_text = window.sessionStorage.getItem(`pr_text_${i}`);
          // check if pr_text isProfane, and if it is, set the submit button to disabled and do not continue
          if (this.isProfane(pr_text)) {
            const submitButton = document.getElementById('btn_personalization_save');
            this.submitButton.disabled = true;
            return;
          }
          const pr_icon = window.sessionStorage.getItem(`pr_icon_${i}`);
          const pr_hexcolor = window.sessionStorage.getItem(`pr_hexcolor_${i}`);
          let pr_summary = '';
          let pr_with = '';
          let hasText = false;
          let hasIcon = false;

          // set new session storage values
          if (pr_hexcolor) {
            window.sessionStorage.setItem(`saved_pr_hexcolor_${i}`, pr_hexcolor);
          }
          if (pr_text && pr_text != '') {
            window.sessionStorage.setItem(`saved_pr_text_${i}`, pr_text);
            pr_summary = pr_text;
            show_edit_personalization = true;
            pr_with = 'with text';
            hasText = true;
          } else {
            // if pr_text is not set we need to delete saved_pr_text if saved_pr_text exists
            const text = window.sessionStorage.getItem(`saved_pr_text_${i}`);
            if (text) {
              window.sessionStorage.removeItem(`saved_pr_text_${i}`);
            }
          }

          if (pr_icon && pr_icon != '') {
            window.sessionStorage.setItem(`saved_pr_icon_${i}`, pr_icon);
            if (pr_summary != '') {
              pr_summary += ' / ';
            }
            pr_summary += `${pr_icon} icon`;
            show_edit_personalization = true;
            pr_with = 'with icon';
            hasIcon = true;
          } else {
            // if pr_icon is not set we need to delete saved_pr_icon if saved_pr_icon exists
            const icon = window.sessionStorage.getItem(`saved_pr_icon_${i}`);
            if (icon) {
              window.sessionStorage.removeItem(`saved_pr_icon_${i}`);
            }
          }

          if (addedValuesWrapper) {
            addedValuesWrapper.querySelector(`#customize-summary-item-${i}`).textContent = `${i} - ${pr_summary}`;
          }

          // console.log(pr_edit_value);
          if (hasText && hasIcon) {
            pr_with = 'with icon and text';
          }
          // create hidden input with name "properties[p1]" and value "pr_summary" if doesn't already exist, if it does exist, update it
          let personalization_data = document.querySelector(`input[name="properties[p${i}]"]`);
          if (!personalization_data) {
            personalization_data = document.createElement('input');
            personalization_data.type = 'hidden';
            personalization_data.name = `properties[p${i}]`;
            personalization_data.value = pr_summary;
            this.form.appendChild(personalization_data);
          } else {
            personalization_data.value = pr_summary;
          }

          // convert this.model to lowercase and no spaces
          const this_model = this.getCleanedModel();
          const this_finish = this.getCleanedFinish();
          const personalization_db_value = {
            type: this.personalization_type,
            size: this_model,
            color: this_finish,
            print_color: pr_hexcolor,
            print_text: pr_text,
            print_icon: pr_icon,
            template_name: `${this_model}_${this_finish}`,
          };
          _personalization_data[`_pr_db_${i}`] = personalization_db_value;
        }

        this._compactPersonalizationSlots(_personalization_data, slide_count, addedValuesWrapper);

        this.toggleEditPersonalization(show_edit_personalization);

        const input_personalization = document.getElementById('properties-personalization-line-item');
        input_personalization.value = JSON.stringify(_personalization_data);
      };

      // Compacts filled slots so they always start at index 1 — the order
      // integration treats a missing _pr_db_1 as "no personalization", so a
      // 2-pack with only slot 2 personalized must be promoted to slot 1.
      // Mutates personalizationData in place; also shifts session storage,
      // properties[pN] inputs, and #customize-summary-item-N text.
      _compactPersonalizationSlots(personalizationData, slideCount, addedValuesWrapper) {
        const slotIsFilled = (i) => {
          const t = window.sessionStorage.getItem(`saved_pr_text_${i}`);
          const ic = window.sessionStorage.getItem(`saved_pr_icon_${i}`);
          return (!!t && t !== '') || (!!ic && ic !== '' && ic !== 'none');
        };
        const filledIndices = [];
        for (let i = 1; i <= slideCount; i++) {
          if (slotIsFilled(i)) filledIndices.push(i);
        }
        const needsCompaction = filledIndices.some((origIdx, newSlot) => origIdx !== newSlot + 1);
        if (!needsCompaction) return;

        const snapshots = filledIndices.map((origIdx) => {
          const pInputEl = this.form.querySelector(`input[name="properties[p${origIdx}]"]`);
          return {
            savedText: window.sessionStorage.getItem(`saved_pr_text_${origIdx}`),
            savedIcon: window.sessionStorage.getItem(`saved_pr_icon_${origIdx}`),
            savedHex: window.sessionStorage.getItem(`saved_pr_hexcolor_${origIdx}`),
            workingText: window.sessionStorage.getItem(`pr_text_${origIdx}`),
            workingIcon: window.sessionStorage.getItem(`pr_icon_${origIdx}`),
            workingHex: window.sessionStorage.getItem(`pr_hexcolor_${origIdx}`),
            db: personalizationData[`_pr_db_${origIdx}`],
            pValue: pInputEl ? pInputEl.value : '',
          };
        });

        for (let i = 1; i <= slideCount; i++) {
          delete personalizationData[`_pr_db_${i}`];
          window.sessionStorage.removeItem(`saved_pr_text_${i}`);
          window.sessionStorage.removeItem(`saved_pr_icon_${i}`);
          window.sessionStorage.removeItem(`saved_pr_hexcolor_${i}`);
          window.sessionStorage.removeItem(`pr_text_${i}`);
          window.sessionStorage.removeItem(`pr_icon_${i}`);
          window.sessionStorage.removeItem(`pr_hexcolor_${i}`);
          const stalePInput = this.form.querySelector(`input[name="properties[p${i}]"]`);
          if (stalePInput) stalePInput.remove();
          const staleSummaryEl = addedValuesWrapper?.querySelector(`#customize-summary-item-${i}`);
          if (staleSummaryEl) staleSummaryEl.textContent = '';
        }

        snapshots.forEach((snap, idx) => {
          const newIdx = idx + 1;
          if (snap.savedText) window.sessionStorage.setItem(`saved_pr_text_${newIdx}`, snap.savedText);
          if (snap.savedIcon) window.sessionStorage.setItem(`saved_pr_icon_${newIdx}`, snap.savedIcon);
          if (snap.savedHex) window.sessionStorage.setItem(`saved_pr_hexcolor_${newIdx}`, snap.savedHex);
          if (snap.workingText) window.sessionStorage.setItem(`pr_text_${newIdx}`, snap.workingText);
          if (snap.workingIcon) window.sessionStorage.setItem(`pr_icon_${newIdx}`, snap.workingIcon);
          if (snap.workingHex) window.sessionStorage.setItem(`pr_hexcolor_${newIdx}`, snap.workingHex);
          if (snap.db) personalizationData[`_pr_db_${newIdx}`] = snap.db;
          const newPInput = document.createElement('input');
          newPInput.type = 'hidden';
          newPInput.name = `properties[p${newIdx}]`;
          newPInput.value = snap.pValue;
          this.form.appendChild(newPInput);
          const newSummaryEl = addedValuesWrapper?.querySelector(`#customize-summary-item-${newIdx}`);
          if (newSummaryEl) newSummaryEl.textContent = `${newIdx} - ${snap.pValue}`;
        });
      }

      toggleEditPersonalization = (show_edit_personalization) => {
        const customizeEditWrapper = document.querySelector('[data-customize-edit-wrapper]');
        const customizeDescriptionEl = document.querySelector('[data-customize-description]');

        if (show_edit_personalization) {
          customizeEditWrapper?.classList.remove('hidden');
          customizeDescriptionEl?.classList.add('hidden');
          customizeEditWrapper.setAttribute('data-customize-edit-wrapper', 'active');
        } else {
          customizeEditWrapper?.classList.add('hidden');
          customizeDescriptionEl?.classList.remove('hidden');
          customizeEditWrapper.setAttribute('data-customize-edit-wrapper', 'inactive');
          // document.querySelector('input[name=id].product-variant-id').value = document.querySelector('input[name="id"]').value;
        }
        // fire custom event that the Personalization has been updated
        //        this.dispatchEvent(new CustomEvent('personalizationUpdated', { bubbles: true }));
      };

      resetCustomize() {
        if (this.debug) console.log('resetCustomize()');
        const totalSlides = this.getTotalSlidesNumber();
        if (this.debug) console.log(`totalSlides: ${totalSlides}`);
        // Loop through slides to remove personalization data from session storage
        for (let i = 1; i <= this.max_num_slides; i++) {
          // Remove session storage items
          const keys = [
            `pr_text_${i}`,
            `pr_icon_${i}`,
            `pr_hexcolor_${i}`,
            `previewText_${i}`,
            `saved_pr_text_${i}`,
            `saved_pr_icon_${i}`,
            `saved_pr_hexcolor_${i}`,
          ];
          // loop through each key and if it exists, remove it
          keys.forEach((key) => {
            // if key exists in sessionStorage, remove it
            if (key in window.sessionStorage) {
              if (this.debug) console.log(`key: ${key}`);
              window.sessionStorage.removeItem(key);
            }
          });

          // Clear preview text if element exists
          const previewText = document.querySelector(`#preview-text-${i} .text_with_icon`);
          if (previewText) {
            previewText.innerHTML = '';
          }
          const previewImg = document.querySelector(`#preview-text-${i} img`);
          if (previewImg) {
            previewImg.remove();
          }

          // make sure to reset customize-summary-item-[i] text content for all possible
          const customizeSummaryItem = document.querySelector(`#customize-summary-item-${i}`);
          if (customizeSummaryItem) {
            customizeSummaryItem.textContent = '';
          }
        }

        // Reset HTML values
        // this.setPersonalization(' ', 'none');

        // Clear text input if it exists
        const prText = document.getElementById('pr_text');
        if (prText) {
          prText.value = '';
          this.pr_text = '';
          this.pr_icon = '';
        }

        const iconBtns = document.querySelectorAll('[data-icon-value]');
        iconBtns?.forEach((btn) => btn.setAttribute('data-modal-button-state', 'initial'));

        this.toggleEditPersonalization(false);

        // Clear hidden input and remove personalization inputs
        const propertiesInput = document.getElementById('properties-personalization-line-item');
        if (propertiesInput) propertiesInput.value = '';

        const productForm = document.querySelector('config-cart-summary product-form');
        if (productForm) {
          const personalizationInputs = productForm.querySelectorAll('input[name^="properties[p"]');
          personalizationInputs.forEach((input) => input.remove());
        }
      }

      getHexColor(finish = '') {
        if (this.debug) console.log('getHexColor()');
        let hexcolor = '63666A';
        let iconcolor = 'black';

        if (this.personalization_type === 'embroidery') {
          switch (finish) {
            case 'black':
              hexcolor = '9F9F9F';
              break;
            case 'chrome':
              hexcolor = '7E7E82';
              break;
            case 'white':
              hexcolor = '808194';
              break;
            default:
              hexcolor = '63666A';
          }
        } else if (this.personalization_type === 'uv_printing') {
          switch (finish) {
            case 'matte_black':
              hexcolor = '939598';
              iconcolor = 'gray';
              break;
            case 'brushed':
              hexcolor = '1A091A';
              iconcolor = 'black';
              break;
            case 'brass':
              hexcolor = '1A091A';
              iconcolor = 'black';
              break;
            case 'chrome':
              hexcolor = '1A091A';
              iconcolor = 'black';
              break;
            case 'polished':
              hexcolor = '1A091A';
              iconcolor = 'black';
              break;
            case 'white':
              hexcolor = 'B1B3B6';
              iconcolor = 'light-gray';
              break;
            default:
              hexcolor = '1A091A';
              iconcolor = 'black';
          }
        }
        if (this.debug) console.log(`hexcolor: ${hexcolor}; iconcolor: ${iconcolor}`);
        return { hexcolor, iconcolor };
      }

      getTotalSlidesNumber() {
        const pr_slider = document.querySelector('.swiper-customize-images-container');
        if (!pr_slider) return;
        return pr_slider.querySelectorAll('.swiper-slide').length;
      }

      getCleanedModel() {
        return this.model.replace(/\s+/g, '').toLowerCase();
      }

      getCleanedFinish() {
        return this.finish.replace(/\s+/g, '_').toLowerCase();
      }

      // get the words from badWordsList
      isProfane(string) {
        // replace * of word with .*
        return (
          this.badWordsList.filter((word) => {
            const wordExp = new RegExp(`\\b${word.replace(/(\W)/g, '.$1')}\\b`, 'gi');
            return wordExp.test(string);
          }).length > 0 || false
        );
      }
    }
  );
}
